import logoZhTw from "../assets/images/logoZhTw.webp";
import logoEn from "../assets/images/logoEN.png";
import logoZh from "../assets/images/logo-cn2@2x.webp";
import { useTranslation } from "react-i18next";

const useLogoByLocale = (locale) => {
  const { i18n } = useTranslation();
  switch (i18n.language) {
    case "zh-TW":
      return logoZhTw;
    case "en":
      return logoEn;
    case "zh":
      return logoZh;
    default:
      return logoZhTw;
  }
};

export { useLogoByLocale };
